<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <div class="row">
              <div class="d-flex align-items-center">

                <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                  
                  <div class="search-input">
                      <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                              alt="img" /></a>
                      <div id="DataTables_Table_0_filter" class="dataTables_filter">
                          <label>
                              <input type="search" class="form-control form-control-sm"
                                  placeholder="Search..." aria-controls="DataTables_Table_0"
                                  v-model="query" />
                          </label>
                      </div>
                  </div>
  
  
                    
                </div>
                <div class="wordset">
                    <ul>
                        <!-- <li class="" >
                            <router-link class=" d-flex flex-column justify-content-between  align-items-center " to="importschedule" style="margin-top: 15px !important; margin-bottom: 0px !important;"><vue-feather
                                    type="upload" class="text-success"></vue-feather> <span class="text-black">Import</span></router-link>
                        </li> -->

                        <li>
                            <div class="form-group" style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <!-- <datepicker v-model="periode" class="picker" :editable="true"
                                        :clearable="false" @update:modelValue="index" /> -->
                                    <!-- <a class="addonset">
                                        <i class='bx bx-calendar'></i>
                                    </a> -->
                                    <DatePicker 
                                        v-model:value="periode" 
                                        type="date"
                                        range
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :clearable="true"
                                        class="picker"
                                        style="width: 268px !important;" 
                                    />

                                    <!-- @change="onDateChange" -->
                                    
                                </div>
                            </div>
                        </li>

                        <li class="d-flex align-items-center gap-3">
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Generate"
                                @click="generateData"
                                class="d-flex flex-column justify-content-center  align-items-center mt-2 btn btn-primary p-1">
                                <i class='bx bx-refresh' style="font-size: 25px;"></i> 
                                <!-- <span
                                    class="text-black">
                                    generate
                                </span> -->
                            </a>

                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                @click="insert"
                                class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2"><img
                                    src="../../../assets/img/Import_fill.png" alt="img" width="25" /> 
                                    <!-- <span
                                    class="text-black">
                                    excel
                                </span> -->
                            </a>

                            

                        </li>
  
                        
                        
  
                    </ul>
                </div>

              </div>
              
              <div class="table-responsive mt-3">
                  <a-table :columns="columns" :data-source="filteredData">
                      <template #bodyCell="{ column, record }">
                          <template v-if="column.key === 'no'">
                              <div class="productimgname">
                                  {{ record.no }}
                              </div>
                          </template>
                          <!-- <template v-if="column.key === 'deskripsi'">
                              <div class="productimgname">
                                  {{ shortenDescription(record.deskripsi) }}
                              </div>
  
  
                          </template> -->

                          <template v-if="column.key === 'nominal_bpjs_kesehatan'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.nominal_bpjs_kesehatan) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'nominal_bpjs_tk'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.nominal_bpjs_tk) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'nomor_bpjs_kesehatan'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.nomor_bpjs_kesehatan) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'nomor_bpjs_tk'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.nomor_bpjs_tk) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'phone'">
                              <p class="text-end">
                                  {{ record.phone }}
                              </p>
  
  
                          </template>

  
                         
  
                          <!-- <template v-else-if="column.key === 'action'">
                              
                              <router-link class="me-3" to="editother_deduction" @click="edit(record);">
                                  <img src="@/assets/img/icons/edit.svg" alt="img" />
                              </router-link>
                              <a class="confirm-text" href="javascript:void(0);"
                                  @click="terminate(record.id, record.nama_departemen); showModal('terminate');">
                                  <img src="@/assets/img/icons/delete.svg" alt="img" />
                              </a>
                          </template> -->
                      </template>
                  </a-table>
              </div>

              
            </div>


          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, goPage, AlertBottom, rupiah, rupiahNonIdr } from "@/assets/js/function";

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'

// import { Form, Field } from "vee-validate";
// import * as Yup from "yup";

export default {
  // components: {
  //   Form,
  //   Field,
  // },
  components: {
        DatePicker
        
  },

  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "BPJS Confirmation Report",
      title1: "generate bpjs confirmation report",
      config: "",
      api: "",

       // periode: new Date(),
      periode: [],

      data: [],
      

      columns: [
              {
                  title: "No",
                  dataIndex: "no",
                  key: "no",
                   align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.no.toLowerCase();
                          b = b.no.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
              
              {
                  title: "Employee",
                  dataIndex: "name",
                  key: "name",
                  sorter: {
                      compare: (a, b) => {
                          a = a.name.toLowerCase();
                          b = b.name.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "BPJS Kesehatan",
                  dataIndex: "nominal_bpjs_kesehatan",
                  key: "nominal_bpjs_kesehatan",
                  sorter: {
                      compare: (a, b) => {
                          a = a.nominal_bpjs_kesehatan.toLowerCase();
                          b = b.nominal_bpjs_kesehatan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "BPJS TK",
                  dataIndex: "nominal_bpjs_tk",
                  key: "nominal_bpjs_tk",
                  sorter: {
                      compare: (a, b) => {
                          a = a.nominal_bpjs_tk.toLowerCase();
                          b = b.nominal_bpjs_tk.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "BPJS Kesehatan Number",
                  dataIndex: "nomor_bpjs_kesehatan",
                  key: "nomor_bpjs_kesehatan",
                  sorter: {
                      compare: (a, b) => {
                          a = a.nomor_bpjs_kesehatan.toLowerCase();
                          b = b.nomor_bpjs_kesehatan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "BPJS TK Number",
                  dataIndex: "nomor_bpjs_tk",
                  key: "nomor_bpjs_tk",
                  sorter: {
                      compare: (a, b) => {
                          a = a.nomor_bpjs_tk.toLowerCase();
                          b = b.nomor_bpjs_tk.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Phone",
                  dataIndex: "phone",
                  key: "phone",
                  sorter: {
                      compare: (a, b) => {
                          a = a.phone.toLowerCase();
                          b = b.phone.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
              

              // {
              //     title: "Action",
              //     key: "action",
              //     sorter: false,
              // },
      ],

      //filter
      query: "",
    //   setting_break_button: "0",

      //data
      currentData: {
      },
      startDate: new Date,
      endDate: new Date,

      formatFilter: "EXCEL",
      FormatList: ["PDF", "EXCEL"],
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 1200000,
    }

    // Set default date range (1st to last day of current month)
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // zero-based
    const start = new Date(year, month, 1);
    const end = new Date(year, month + 1, 0);


    this.periode = [
      this.formatDateLocal(start),
      this.formatDateLocal(end),
    ];

    // this.index()

  },

  computed: {
    filteredData() {
      // If no query entered, return all data
      if (this.query === '') {
        return this.data;
      }

      const lowerCaseQuery =  (this.query || '').toLowerCase();

      return this.data.filter(item => {
        return (
          (item.name || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.nominal_bpjs_kesehatan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.nominal_bpjs_tk || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.nomor_bpjs_kesehatan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.nomor_bpjs_tk || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.phone || '').toLowerCase().includes(lowerCaseQuery)
        );
      });
    }
  },
  // setup() {

  //   const schema = Yup.object().shape({
  //     name: Yup.string().required("Phone Number is required"),

  //   });

  //   return {
  //     schema,

  //   };
  // },
  methods: {

    rupiah,
    rupiahNonIdr,

    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    formatDateLocal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    generateData() {
        this.index()
    },

    insert() {
        ShowLoading();
        let formData = new FormData();
        const savedBranch = localStorage.getItem("selectedBranch") || '';
        const company_type = localStorage.getItem("company_type") || '';
        const company_default = localStorage.getItem("company_default") || '';
        formData.append("company_type", company_type);
        if (company_type === "branch") {
            formData.append("company_id", company_default);
        } else {
            formData.append("company_id", (savedBranch === "0" || !savedBranch) ? company_default : savedBranch);
        }

      // Ensure periode has both start and end dates
      if (this.periode && this.periode.length === 2) {
          const [startDate, endDate] = this.periode;
          formData.append("dfrom",  startDate);  // end date
          formData.append("dto", endDate);  // start date
      }

      formData.append('format', this.formatFilter);

      for (let [key, value] of formData.entries()) {
          console.log(key, value);
      }
      // CloseLoading(); return;

      if (process.env.NODE_ENV === "development") {
        this.api = base_url + 'owners/reports/bpjs_excel';
      } else {
        this.api = base_url + 'owners/reports/bpjs_excel';
      }

      axios
        .post(this.api, formData, this.config)
        .then((response) => {
          if (response.data.status == true) {
            CloseLoading();
            window.open(response.data.data.file_report, "_blank");
          } else {
            AlertPopup("error", "", response.data.message, 1500, false);
          }
        })
        .catch((error) => {
          ErrorConnectionTimeOut(error);
        })
        .finally((error) => {
            CloseLoading(); return;
        });
    },

    onDateChange(value) {
        this.periode = value;
        this.index();
    },

    index() {
        ShowLoading();
        let formData = new FormData();
        const savedBranch = localStorage.getItem("selectedBranch") || '';
        const company_type = localStorage.getItem("company_type") || '';
        const company_default = localStorage.getItem("company_default") || '';
        formData.append("company_type", company_type);
        if (company_type === "branch") {
            formData.append("company_id", company_default);
        } else {
            formData.append("company_id", (savedBranch === "0" || !savedBranch) ? company_default : savedBranch);
        }

      // Ensure periode has both start and end dates
      if (this.periode && this.periode.length === 2) {
          const [startDate, endDate] = this.periode;
          formData.append("dfrom",  startDate);  // end date
          formData.append("dto", endDate);  // start date
      }
      
      for (let [key, value] of formData.entries()) {
          console.log(key, value);
      }
      // CloseLoading(); return;

      if (process.env.NODE_ENV === "development") {
          this.api = base_url + 'owners/reports/bpjs';
      } else {
          this.api = base_url + 'owners/reports/bpjs';
      }
      axios
          .post(this.api, formData, this.config)
          .then((response) => {
              console.log(response.data)
              if (response.data.status == true) {
                  this.data = [];

                  response.data.data.forEach((item, index) => {
                      let item_prepare = { ...item, no: (index + 1), };
                      this.data.push(item_prepare);
                  });
              } else {
                  AlertPopup("error", "", response.data.message, 1500, false);
              }
          })
          .catch((error) => {
              ErrorConnectionTimeOut(error);
          })
          .finally((error) => {
                CloseLoading(); return;
            });

    },



  },

};
</script>

